import { Direction } from "react-toastify/dist/utils";

export const initialState: any = {
    MediaName: "",
    Comment: "",
    Height: 1.5,
    SpeedTime: 5,
    FreeText: "",
    Color: "#ffffff",
    FreeTextHTML: "",
    Direction: 1,
    IsScroll: false
  }